module.exports = __webpack_public_path__ + "static/img/christian-stahl-8S96OpxSlvg-unsplash_thumb.cdfaa20.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/christian-stahl-8S96OpxSlvg-unsplash_thumb.png
// module id = kCA6
// module chunks = 4